export var toggleCategoryState = function (_a) {
    var categoryIndex = _a.categoryIndex, setCurrentCategory = _a.setCurrentCategory, currentCategory = _a.currentCategory, setHasCategoryOpen = _a.setHasCategoryOpen;
    var oldValue = currentCategory;
    var newValue = currentCategory !== categoryIndex ? categoryIndex : null;
    var shouldScroll = newValue !== currentCategory && newValue !== null && oldValue !== null;
    setCurrentCategory(newValue);
    setHasCategoryOpen(newValue !== null);
    if (shouldScroll) {
        // delay a little to achieve a smoother scrolling effect while the panel is collapsing
        setTimeout(function () {
            window.scroll({
                top: 0,
                behavior: "smooth",
            });
        }, 100);
    }
};
//# sourceMappingURL=helpers.js.map